/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { CONFIGS_API } from 'services/constants';
import { RefPricingResponse } from 'services/types';
import { isApiFetchingCompletedAction } from '../utils';

const isConfigssApiFullfilledAction = isApiFetchingCompletedAction(CONFIGS_API);

export interface ConfigsState {
  refPricing: RefPricingResponse[];
}

const initialState: ConfigsState = {
  refPricing: [],
};

export const configsSlice: Slice<ConfigsState> = createSlice({
  name: 'configsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isConfigssApiFullfilledAction,
      (state, action: PayloadAction<RefPricingResponse[]>) => {
        state.refPricing = action.payload;
      }
    );
  },
});
